import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/** YYYY-MM-DD for `<input type="date">`. */
function todayISO(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Read/write `?date=YYYY-MM-DD` in the URL.
 *
 *  - `date` is what's in the URL right now (or null if not set)
 *  - `setDate(iso)` updates the URL — pass `null` to clear (revert to "auto").
 *  - `effective` is the date the API should be hit with (null = let the
 *    backend pick latest/today).
 *  - `today` is the system clock's idea of today, for the `[today]` button.
 */
export function useBusinessDate() {
  const [params, setParams] = useSearchParams();
  const today = useMemo(() => todayISO(), []);
  const date = params.get("date");

  const setDate = useCallback((iso: string | null) => {
    const next = new URLSearchParams(params);
    if (iso) next.set("date", iso);
    else     next.delete("date");
    setParams(next, { replace: true });
  }, [params, setParams]);

  return { date, setDate, today };
}
